import React from 'react';
import { FormattedMessage } from 'react-intl';
const Unsupported = () => {
    return React.createElement(FormattedMessage, { id: "chat.message.unsupported" });
};
export default Unsupported;
//# sourceMappingURL=Unsupported.js.map